import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {SelectItem} from 'primeng/primeng';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class AddComponent implements OnInit {
  customer_code: any;
  customer_id: any;
  cities: SelectItem[];

  constructor() {
    this.cities = [];
    this.cities.push({label:'Select', value:null});
    this.cities.push({label:'New York', value:{id:1, name: 'New York', code: 'NY'}});
    this.cities.push({label:'Rome', value:{id:2, name: 'Rome', code: 'RM'}});
    this.cities.push({label:'London', value:{id:3, name: 'London', code: 'LDN'}});
    this.cities.push({label:'Istanbul', value:{id:4, name: 'Istanbul', code: 'IST'}});
    this.cities.push({label:'Paris', value:{id:5, name: 'Paris', code: 'PRS'}});
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/add/add.component.ts